import { generatePath } from 'react-router-dom';

import { authenticatedGiftingPaths, authenticatedPaths } from 'app/constants/routes';

export function getBlankPath() {
  return authenticatedPaths.home.path;
}

export function getMyProfilePath() {
  return authenticatedPaths.profile.path;
}

export function getChangePasswordPath() {
  return authenticatedPaths.changePassword.path;
}

export function getEmployeesPath() {
  return authenticatedPaths.employees.path;
}

export function getEmployeeProfilePath(employeeId: string) {
  return generatePath(authenticatedPaths.employeeProfile.path, { employeeId });
}

export function getAdminProfilePath(adminId: string) {
  return generatePath(authenticatedPaths.adminProfile.path, { adminId });
}

export function getReportsPath() {
  return authenticatedPaths.reports.path;
}

export function getImportEmployeesPath() {
  return authenticatedPaths.importEmployees.path;
}

export function getGiftingImportEmployeesPath() {
  return authenticatedGiftingPaths.importEmployees.path;
}

export function getGiftingPath() {
  return authenticatedPaths.gifting.path;
}

export function getRewardEmployeesPath() {
  return authenticatedPaths.rewardEmployees.path;
}
